import { render, staticRenderFns } from "./Completed.vue?vue&type=template&id=373949ad&scoped=true"
import script from "./Completed.vue?vue&type=script&lang=js"
export * from "./Completed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373949ad",
  null
  
)

export default component.exports